import { ChangeDetectionStrategy, Component, inject, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtilityService } from "../../../core/services/utility.service";
import { UserRole } from '../../../core/types/auth.types';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-update-input-number',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './update-input-number.component.html',
  styleUrl: './update-input-number.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateInputNumberComponent {
  startValue = model.required<number>();
  rolesWhichCanEdit = input<Array<UserRole>>([]);
  onlyReadonlyField = input<boolean>(false);
  saveValue = output<number>();
  editState = output<boolean>();

  private utilityService: UtilityService = inject(UtilityService);
  private authService: AuthService = inject(AuthService);

  public isEditState = signal<boolean>(false);

  public openEditState(): void {
    if (!this.isUserCanEdit()) { return; }

    this.isEditState.set(true);
    this.editState.emit(this.isEditState());
  }

  public isUserCanEdit(): boolean {
    if (!this.rolesWhichCanEdit().length) { return true; }
    if (this.onlyReadonlyField()) { return false; }

    const userRoles: Array<UserRole> = this.authService.getUserRoles();
    return this.utilityService.isArrayContainsAnyElementOfAnotherArray(userRoles, this.rolesWhichCanEdit());
  }

  public closeEditState(): void {
    this.isEditState.set(false);
    this.editState.emit(this.isEditState());
  }

  public handleSaveValue(): void {
    this.saveValue.emit(this.startValue());
    this.closeEditState();
  }

  public handleResetValue(): void {
    this.closeEditState();
  }

  public handeEditValue(): void {
    this.openEditState();
  }

  public formatNumberValue(value: number | string): string {
    return this.utilityService.formatBudgetValue({ value: Number(value) });
  }
}
